import { getEnvKey } from 'utils/getEnvValue';

export const models = [
  'template-article',
  'template-claims-lesson',
  'template-course',
  'template-podcast',
  'template-risk-assessment',
  'template-risk-report',
  'template-toolkit',
  'template-video',
];

export const convertIdToModelName = (id: string): string => {
  const envPrefix = getEnvKey({
    DEV: 'd79eef3bde0445518e995ef57333cd0d_',
    UAT: '28afc672302a4fae8b3988f7f7225dc1_',
    QA: '93aadb18021a441ba7c99eb365b6f7a1_', // TODO: REPLACE WITH QA ENV KEY WHEN AVAILABLE
    PROD: '',
  });
  let resourceName = '';

  switch (id) {
    case `${envPrefix}00ae5ef151ff4c9a84ef99e73386381f`:
      resourceName = 'Article';
      break;
    case `${envPrefix}b28df6934c7b4d2d9007f285e766546f`:
      resourceName = 'Claims Lesson';
      break;
    case `${envPrefix}fa7c922190244b9a820b0155b7042c89`:
      resourceName = 'Course';
      break;
    case `${envPrefix}4f3d4305f43646a4bb98b29a0705c311`:
      resourceName = 'Podcast';
      break;
    case `${envPrefix}fe5725f1ddc049298500953c647dbd62`:
      resourceName = 'Risk Assessment';
      break;
    case `${envPrefix}4ef2e04a955a45fbb3fe3223040f8ef1`:
      resourceName = 'Risk Report';
      break;
    case `${envPrefix}bb24c5e231a14e259c300e3e8b5e631c`:
      resourceName = 'Toolkit';
      break;
    case `${envPrefix}e50a3d2cacf04e43a3ee7537b0286cfd`:
      resourceName = 'Video';
      break;
    default:
      return '';
  }

  return resourceName;
};
